/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.ServiceCategories {
  angular.module("meevo.plugins.serviceCategories", []);
}